import { useContext } from "react";
import { filteredQuestionIds } from "../../../Common/CommonFunctions/filterQuestionIds";
import { ActionKind } from "../../../SupplierView/SupplierViewPropsTypes";
import DropDown from "../Components/DropDown";
import DropDownMobileView from "../Components/DropDownMobileView";
import { DropDownPropsTypes } from "../DropDownPropsTypes";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";

function DropDownContainer({
  surveyAnswers,
  setSurveyAnswers,
  questionId,
  isPreview,
  questionObjVariable,
  oldOption,
  mainRefObject,
  checkNestedDependency,
  dependencyAnsHash,
  setDependencyAnsHash,
  dispatch,
  reducerState,
  surveyAnswersInfo,
}: DropDownPropsTypes) {
  const { isMobile } = useContext(CheckResponsiveContext);
  //drop-down
  const handleChangeInputDropDown: DropDownPropsTypes["handleChangeInputDropDown"] =
    (questionId, e) => {
      const { value } = e.target;
      const newValue = value.split("|");
      oldOption!.current = surveyAnswers?.[questionId]?.optionId! ?? "";
      let surveyAnswersCopy = structuredClone(surveyAnswers);
      surveyAnswersCopy[questionId] = surveyAnswersCopy[questionId] || {};
      surveyAnswersCopy[questionId]["val"] = newValue[0];
      surveyAnswersCopy[questionId]["optionId"] = newValue[1];

      if (surveyAnswersInfo.surveyInfo.isScoreEnable) {
        surveyAnswersCopy[questionId]["score"] = Number(
          questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
            newValue?.[1]
          ]?.weightage
        );
      }
      //dependency part
      if (questionObjVariable?.[questionId]?.dependentChildren.length) {
        let dependencyAnsHashCopy = new Set(dependencyAnsHash);
        if (oldOption!.current.length) {
          dependencyAnsHashCopy.delete(oldOption!.current);
          mainRefObject!.current.questionOptionsInfoRef.current
            .get(questionId)
            ?.selectedoptionsIds.delete(oldOption!.current);
          mainRefObject!.current.questionOptionsInfoRef.current.get(questionId)
            ?.selectedoptionsIds.size === 0 &&
            mainRefObject!.current.questionOptionsInfoRef.current.delete(
              questionId
            );
        }
        if (
          questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
            newValue[1]
          ].dependentQuestionIds.length
        ) {
          dependencyAnsHashCopy.add(newValue[1]);

          // store option ids of current question in map
          mainRefObject!.current.questionOptionsInfoRef.current.set(
            questionId,
            {
              selectedoptionsIds: new Set([newValue[1]]),
            }
          );
        }
        if (oldOption!.current.length) {
          checkNestedDependency!(
            questionObjVariable?.[questionId]?.dependentChildren,
            surveyAnswersCopy,
            dependencyAnsHashCopy
          );
        }
        // filter out questions tht are dependent, and only keep questions to render
        const updatedFilterData = filteredQuestionIds(
          reducerState!.allQuestionIds,
          questionObjVariable,
          dependencyAnsHashCopy
        );
        dispatch!({
          type: ActionKind.QUESTION_IDS_TO_RENDER,
          payload: { updatedFilterData: updatedFilterData },
        });
        setDependencyAnsHash!(dependencyAnsHashCopy);
      }
      setSurveyAnswers!(surveyAnswersCopy);
    };
  return (
    <>
      {isMobile ? (
        <DropDownMobileView
          handleChangeInputDropDown={handleChangeInputDropDown}
          surveyAnswers={surveyAnswers}
          questionId={questionId}
          questionObjVariable={questionObjVariable}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      ) : (
        <DropDown
          handleChangeInputDropDown={handleChangeInputDropDown}
          surveyAnswers={surveyAnswers}
          questionId={questionId}
          questionObjVariable={questionObjVariable}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      )}
    </>
  );
}

export default DropDownContainer;
